<template>
    <div>
        <el-dialog
            :visible.sync="$store.getters.showOrderSkusDialog"
            width="80%"
            :before-close="handleClose"
        >
            <el-container>
                <el-main>
                    <el-table :data="skusSelected" style="width: 100%" empty-text="Не продуктов">
                        <el-table-column
                                prop="id"
                                label="Id"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="Название"
                                width="200"
                        />
                        <el-table-column
                                prop="price"
                                label="Цена без скидки"
                        />
                        <el-table-column
                                prop="productSku"
                                label="Свойства"
                        >
                            <template #default="scope">
                                <template v-if="scope.productSku && scope.productSku.options.length>0">
                                    <p v-for="value in scope.productSku.options" :key="value.id">
                                        {{ value.title }} : {{ value.value }}
                                    </p>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Доступные скидки"
                                width="300"
                                props="productSku"
                        >
                            <template #default="scope">
                                <template v-if="scope.productSku && scope.productSku.priceTypes.length>0">
                                    <p v-for="action in scope.productSku.priceTypes" :key="action.title">
                                        {{ action.title }}({{action.price}})
                                        <!-- {{ action.title }}({{ action.from_date }} - {{ action.to_date }}) -
                                        {{ action.discount }} % -->
                                    </p>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Количество"
                            props="amount"
                            align="center"
                        >
                            <template #default="scope">
                                <el-row justify="space-between" align="middle" type="flex">
                                    <el-col :span="10" justify="center" align="middle" type="flex">
                                        <el-button size="small" icon="el-icon-minus"  @click="minusQuantity(scope.row.id)" circle></el-button>
                                    </el-col>
                                    <el-col :span="4" justify="center" align="middle" type="flex">
                                        {{ scope.row.amount }}
                                    </el-col>
                                    <el-col :span="10" justify="center" align="middle" type="flex">
                                        <el-button size="small"  icon="el-icon-plus"  @click="plusQuantity(scope.row.id)" circle></el-button>
                                    </el-col>
                                </el-row>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
            </el-container>
            <el-button @click="handleClose">Отмена</el-button>
            <el-button @click="saveSkus">Сохранить</el-button>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import deepClone from '../../../composable/utils/deepClone'
import getErrors from '../../../composable/utils/getErrors';

export default {
    props: ['skusSelected1', 'orderId', 'priceTypeId'],
    data: function () {
        return {
            skusSelected: [],
            skus: [],
            paginator: [],
            q: '',
            onlySelected: false,
            total: 0,
            current:1,
            errors: []
        }
    },
    mounted() {
        this.initSelected()

        // this.getSkus();
    },
    methods: {
        initSelected() {
            this.skusSelected = this.cloneObject(this.skusSelected1)
        },
        handleClose() {
            this.$store.commit('showOrderSkusDialog', false);
            this.initSelected()
        },
        cloneObject(target) {
            return deepClone(target)
        },
        getPage: function (pageNum) {
            let qs = require('qs');
            let query = {
                q: this.q,
                selected: this.skusSelected,
                page: pageNum
            };
            if (pageNum !== null) {
                axios.get(this.paginator.meta.path + '?'+qs.stringify(query)).then((response) => {
                    this.paginator = response.data;
                    this.skus = response.data.data;
                    this.current = pageNum;
                }).catch((errors) => {
                    if (errors.response.status === 401) {
                        this.$router.push('/login');
                    }
                    this.handleClose();
                });
            }
            this.success = '';
            return this.paginator.first_page_url
        },
        getPropsRequset() {
            const result = {
                price_type_id : this.priceTypeId,
                products: []
            }

            result.products = this.skusSelected.map((e) => {
                return {
                    id: e.id,
                    amount: e.amount
                }
            })

            return result
        },
        saveSkus() {
            const props = this.getPropsRequset()
            axios.post('order/'+this.orderId+'/products',props).then(() => {
                this.handleClose()
                this.$emit('updateParent');
            }).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }
                if(errors.response?.data?.message) {
                    this.$notify.error(errors.response?.data?.message ?? 'Не известная ошибка')
                }
                
            });
        },
        minusQuantity(id){
            let index = null;
            this.skusSelected.forEach(function (item){
                if(item.id === id){
                    index = this.skusSelected.indexOf(item);
                }
            },this);
            if (index >= 0) {
                if(this.skusSelected[index].amount === 1){
                    this.skusSelected.splice(index,1);
                } else if(this.skusSelected[index].amount > 0){
                    this.skusSelected[index].amount--;
                }
            }            
        },
        plusQuantity(id){
            let index = null;
            this.skusSelected.forEach(function (item){
                if(item.id === id){
                    index = this.skusSelected.indexOf(item);
                }
            },this);
            if(index >= 0){
                this.skusSelected[index].amount++;
            }
            else{
                this.skusSelected.push({"id":id,"amount":1});
            }

        },
        onlySelect(){
            let query = {
                q: this.q,
                selected: this.skusSelected
            }
            if(this.onlySelected){

                let qs = require('qs');
                axios.get('/api/admin/order/product-skus/selected?' + qs.stringify(query)).then((response) => {
                    this.skus = response.data.data;
                    this.paginator = response.data;
                    this.current = 1;
                }).catch((errors) => {
                    if (errors.response.status === 401) {
                        this.$router.push('/login');
                    }
                    this.handleClose();
                });
            }

        },
        setErrors(err) {
            this.errors = getErrors(err)
        }
    }
}
</script>

<style scoped>

</style>